import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  AnimationProp,
  FaIconComponent,
  IconName,
  SizeProp,
} from '@fortawesome/angular-fontawesome';

@Component({
  standalone: true,
  selector: 'ps-icon',
  imports: [FaIconComponent],
  template: `<fa-icon
    [icon]="[prefix(), name()]"
    [size]="size()"
    [animation]="animation()"
  ></fa-icon>`,
  host: { '[attr.aria-hidden]': 'true' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  /** The animation of the icon */
  public readonly animation = input<AnimationProp>();

  /** The size of the icon */
  public readonly size = input<SizeProp>();

  /** The prefix of the icon */
  public readonly prefix = input<'fas' | 'far'>('fas');

  /** The name of the icon to display */
  public readonly name = input.required<IconName>();
}
